import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { CalendarEvent } from '../Models/common.model';


@Injectable({
  providedIn: 'root'
})
export class EventCalendarService {
    private apiURL = window.location.href;

    constructor(private http: HttpClient) {
      
    }
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }
    getEvents(): Observable<CalendarEvent[]> {
        return this.http.get<CalendarEvent[]>(this.apiURL + '/GetEventsJson/')         
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
